import React from "react";
import { observer } from "mobx-react";
import { NikoFacilityOrderUSIntakePreviewTemplate } from "themes/application/niko-facility-order-us-intake/pages";
import { NikoFacilityOrderUSIntakePreviewViewStore } from "application/niko-facility-order-us-intake/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new NikoFacilityOrderUSIntakePreviewViewStore(rootStore), "nikoFacilityOrderUSIntakePreviewViewStore")
@observer
class NikoFacilityOrderUSIntakePreview extends React.Component {
	render() {
		return <NikoFacilityOrderUSIntakePreviewTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderUSIntakePreview;